<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import unsafeReportAPI from "@/services/standards/communication/unsafeReportAPI.js";
import Swal from "sweetalert2";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Mecanismo de comunicación, auto reporte del SG SST",
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "2.8.1 Mecanismo de comunicación, auto reporte del SG SST ",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Mecanismo de comunicación, auto reporte del SG SST",
          active: true,
        },
      ],

      healt: {
        contact: null,
        health_condition: null,
        file: null,
        type_document_cm_id: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id,
      },

      company: this.$store.getters["company/getCompany"] || null,
      user: this.$store.state.auth || null,

      loading: true,

      item: null,
      itemStatus: null,

      selected: '',
      usersList: [],
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      file: null,
      submitted: false,
    };
  },
  methods: {
    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if(this.file === null){
          name = this.getFile(this.healt.file)
        }else{
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.8.1/Reporte_salud/${this.$route.params.id}/${this.healt.employee_id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/2.8.1/Reporte_salud/${this.$route.params.id}/${this.healt.employee_id}/${name}`;
        }

        const result = await uploadDocument(url, this.file);
        if (result) {
          this.healt.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getHealt() {
      unsafeReportAPI.getHealt(this.$route.params.id).then((response) => {
        this.healt = {
          contact: response.contact,
          health_condition: response.health_condition,
          file: response.file,
          type_document_cm_id: response.type_document_cm_id,
          employee_id: response.employee_id,
          companies_id: response.companies_id,
        };
      })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        unsafeReportAPI.updateHealt(this.$route.params.id, {
          contact: this.healt.contact,
          health_condition: this.healt.health_condition,
          file: this.healt.file,
          type_document_cm_id: this.healt.type_document_cm_id,
          employee_id: this.healt.employee_id,
          companies_id: this.healt.companies_id,
        })
        .then((response) => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 19,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              setTimeout(() => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Informacion actualizada con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              this.$router.go(-1);
            }, 1000)
            })
            .catch((error) => {
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        });
      } else {
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

  },
  mounted() {
    this.getHealt()
    this.getUsers()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">

      <div class="col-md-12">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                    <select required class="form-control" v-model="healt.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Subir archivo de reporte" label-for="file">
                    <b-form-file type="file" id="file" ref="file" name="file" browse-text="Buscar"
                      :placeholder="healt.file ? getFile(healt.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                  <b-form-group label-for="condicion" class="col-md-6 px-2" label="Condición">
                    <select required class="form-control" v-model="healt.contact">
                      <b-form-select-option value="1">
                        Reporte de condición insegura
                      </b-form-select-option>
                      <b-form-select-option value="2">
                        Reporte de condición de salud
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label-for="health_condition" class="col-md-6 px-2"
                    label="Descripción de la condición de salud reportada">
                    <textarea required class="form-control" id="health_condition"
                      v-model="healt.health_condition" rows="2"></textarea>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary ">Guardar</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>

              </form>

            </div>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>